module.exports = __webpack_public_path__ + "img/Zuckerwatte.abc9e36c.jpg";